import useSWR from 'swr';
import { customSWRConfig, customSWRResponse } from '../../model/types';
import { getTenantId } from '../../utils/accountHelper';

enum PublicCompanySettingsMap {
    'COMPANY_NAME' = 'COMPANY_NAME',
    'COMPANY_LOGO' = 'COMPANY_LOGO'
}

interface IPublicCompanySettings {
    id: number;
    key: keyof typeof PublicCompanySettingsMap;
    value: string;
}
export default function usePublicCompanySettings(
    config: customSWRConfig = {}
): customSWRResponse<IPublicCompanySettings[]> {
    return useSWR<IPublicCompanySettings[]>(['/settings/public', getTenantId()], { ...config });
}

export { type PublicCompanySettingsMap, type IPublicCompanySettings };
